<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentScormCourseItem">
        <v-card-title class="text-h6 pp-center">
          Are you sure you want to delete "{{ currentScormCourseItem.originalName }}" Scorm Course?
        </v-card-title>

        <p class="pp-center pb-5">
          This Scorm Course will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="scormCourseItemLoading"/>

      <ConfirmCancelButtons
          :item="currentScormCourseItem"
          :confirm-disabled="scormCourseItemLoading"
          confirm-text="Delete Scorm Course"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />

    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "ScormDelete",
  components: {UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapState(['currentScormCourseItem']),
    ...mapGetters(['scormCourseApiError', 'openDialog', 'currentScormCourseItem', 'scormCourseItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'scormDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteScormCourse', 'clearScormCourseItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearScormCourseItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteScormCourse(this.currentScormCourseItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
